import Typed from "typed.js"

const typed = document.querySelector("#typed_text")
const strings = JSON.parse(typed.dataset.strings)
let options = {
    strings: strings,
    typeSpeed: 150,
    backSpeed: 100,
    backDelay: 800,
    startDelay: 500,
    loop: true,
    showCursor: false,
    cursorChar: "|",
    attr: null
}
if (typed) {
    new Typed("#typed_text", options)
}
